import { render, staticRenderFns } from "./CommentInvoice.vue?vue&type=template&id=5ce82809&"
import script from "./CommentInvoice.vue?vue&type=script&lang=ts&"
export * from "./CommentInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./CommentInvoice.vue?vue&type=style&index=0&id=5ce82809&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports